import React, { FC } from 'react';
import { Form, Button } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { useTranslate } from '@refinedev/core';
import { ICategory } from '../../../../../interfaces';
import styles from '../../../../../pages/applications/create/create.module.scss';
import { Col, Row } from 'antd';
import { useSelect } from '@refinedev/antd';
import {
    Input,
    FormItem,
    Select,
    InputNumber,
    SelectProps,
} from 'components/ui';

interface IngredientFormProps {
    fieldKey: number;
    [key: string]: any;
}

export const IngredientForm: FC<IngredientFormProps> = ({ fieldKey }) => {
    const t = useTranslate();

    const { selectProps: internationalNamesProps } = useSelect<ICategory>({
        resource: 'dictionary/international-names',
        defaultValue: [],
        optionLabel: 'name',

        onSearch: value => [
            {
                field: 'query',
                operator: 'contains',
                value,
            },
        ],

        meta: {},

        pagination: {
            mode: 'server',
        },
    }) as {
        selectProps: SelectProps<ICategory>;
    };

    const { selectProps: quantityUnitProps } = useSelect<ICategory>({
        resource: 'dictionary/measurement-units',
        defaultValue: [],
        optionLabel: 'name',

        onSearch: value => [
            {
                field: 'query',
                operator: 'contains',
                value,
            },
        ],

        meta: {},

        pagination: {
            mode: 'server',
        },
    }) as {
        selectProps: SelectProps<ICategory>;
    };

    return (
        <>
            <Form.List name={[fieldKey, 'activeIngredients']}>
                {(activeIngredients, { add, remove }, { errors, warnings }) => {
                    return (
                        <>
                            {activeIngredients.map((ingredient, index) => (
                                <div
                                    key={ingredient.key}
                                    className={styles.holder}
                                >
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <FormItem
                                                {...ingredient}
                                                name={[ingredient.name, 'name']}
                                                //@ts-ignore
                                                fieldKey={[
                                                    //@ts-ignore
                                                    ingredient.fieldKey,
                                                    'name',
                                                ]}
                                                key={index}
                                            >
                                                <Input
                                                    label={t(
                                                        'applications.fields.name_active_ingredients'
                                                    )}
                                                    style={{ width: '100%' }}
                                                />
                                            </FormItem>
                                        </Col>

                                        <Col span={24}>
                                            <FormItem
                                                {...ingredient}
                                                name={[
                                                    ingredient.name,
                                                    'internationalNameId',
                                                ]}
                                                //@ts-ignore
                                                fieldKey={[
                                                    //@ts-ignore
                                                    ingredient.fieldKey,
                                                    'internationalNameId',
                                                ]}
                                                key={index}
                                            >
                                                <Select
                                                    {...internationalNamesProps}
                                                    label={t(
                                                        'applications.fields.inn'
                                                    )}
                                                    style={{ width: '100%' }}
                                                />
                                            </FormItem>
                                        </Col>

                                        <Col span={24}>
                                            <FormItem
                                                {...ingredient}
                                                name={[
                                                    ingredient.name,
                                                    'quantity',
                                                ]}
                                                //@ts-ignore
                                                fieldKey={[
                                                    //@ts-ignore
                                                    ingredient.fieldKey,
                                                    'quantity',
                                                ]}
                                                key={index}
                                            >
                                                <InputNumber
                                                    style={{ width: '100%' }}
                                                    label={t(
                                                        'applications.fields.quantity_active_ingredients'
                                                    )}
                                                />
                                            </FormItem>
                                        </Col>

                                        <Col span={24}>
                                            <FormItem
                                                {...ingredient}
                                                name={[
                                                    ingredient.name,
                                                    'quantity_unit_id',
                                                ]}
                                                //@ts-ignore
                                                fieldKey={[
                                                    //@ts-ignore
                                                    ingredient.fieldKey,
                                                    'quantity_unit_id',
                                                ]}
                                                key={index}
                                            >
                                                <Select
                                                    {...quantityUnitProps}
                                                    label={t(
                                                        'applications.fields.units_active_ingredients'
                                                    )}
                                                    style={{ width: '100%' }}
                                                />
                                            </FormItem>
                                        </Col>

                                        <Col span={24}>
                                            <Row
                                                justify="end"
                                                gutter={[16, 16]}
                                            >
                                                <Col>
                                                    <Button
                                                        type="text"
                                                        danger
                                                        icon={
                                                            <MinusCircleOutlined />
                                                        }
                                                        onClick={() => {
                                                            remove(
                                                                ingredient.name
                                                            );
                                                        }}
                                                        aria-label={t(
                                                            'buttons.delete'
                                                        )}
                                                    >
                                                        {t('buttons.delete')}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            ))}
                            <Form.Item noStyle>
                                <Button
                                    type="dashed"
                                    onClick={() => {
                                        add();
                                    }}
                                >
                                    <PlusOutlined />{' '}
                                    {t(
                                        'applications.fields.add_active_ingredients'
                                    )}
                                </Button>

                                <Form.ErrorList errors={errors} />
                            </Form.Item>
                        </>
                    );
                }}
            </Form.List>
        </>
    );
};
